import {ReactNode, useState} from "react";
import TextOnlyModal from 'factor-lib/Modals/TextOnlyModal';
import GlobalMessageContext from "./GlobalMessageContext";

const GlobalMessageWrapper = (
    {
        children
    }: {
        children: ReactNode;
    }
) => {
    const [globalMessage, setGlobalMessage] = useState<string | null>(null);
    return (
        <div>
            { !!globalMessage &&
                <TextOnlyModal message={globalMessage}
                               fullMaxWidth={false}
                               maxWidth={null}
                               close={() => setGlobalMessage(null)}
                               buttonsProps={{
                                   text: 'Ok',
                                   id: 'errorButtonId',
                                   isLoading: false,
                                   actionO: () => setGlobalMessage(null)
                               }}/>

            }
            <GlobalMessageContext.Provider value={setGlobalMessage}>
                { children }
            </GlobalMessageContext.Provider>
        </div>
    );
}

export default GlobalMessageWrapper;
